import {ContentType} from 'sdk/src/defines';

type Payload = {
  contentType: ContentType,
  page: number,
};

const initialState = {
  entities: {},
};

const pageReducer = (state = initialState, action: {type: string, payload: Payload}) => {
  switch (action.type) {
    case 'HANDLE_CONTENT_PAGE_SELECTED': {
      const {contentType, page} = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [contentType]: page
        }
      }
    }
    default:
      return state;
  }
};

export default pageReducer;